import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing } from "lucide-react";
import { useApi } from "@/lib/api";
import { useSession } from "@/context/Session";
import { t } from "@/i18n";

export const usDate = (d) => { const [y, m, dd] = d.split("-"); return `${m}/${dd}/${y}`; };

export function CouponAlerts({ className = "", refresh = 0 }) {
  const api = useApi();
  const { me } = useSession();
  const [items, setItems] = useState([]);
  const allowed = me.org?.type !== "property_management" && (me.role === "admin" || (me.access || []).includes("cashier"));
  useEffect(() => { if (allowed) api.get("/coupons/alerts").then((r) => setItems(r.data)).catch(() => {}); }, [api, allowed, refresh]);
  if (!items.length) return null;
  return (
    <div className={`stack-sm ${className}`} data-testid="coupon-alerts">
      {items.map((c) => (
        <div key={c.id} className="banner banner-warn" data-testid={`coupon-alert-${c.code}`}>
          <BellRing size={18} className="shrink-0" />
          <div className="flex flex-col gap-1">
            <b>{t(c.status === "expires_today" ? "Coupon {code} expires today ({date})" : "Coupon {code} expires tomorrow ({date})", { code: c.code, date: usDate(c.expires_on) })}</b>
            <span className="text-sm">{t(me.role === "admin" ? "Let the cashiers know. It can't be accepted after that day." : "Stop accepting it after that day.")}</span>
            {me.role === "admin" && <Link to="/coupons" className="text-sm underline self-start" data-testid={`coupon-alert-manage-${c.code}`}>{t("Manage coupons")}</Link>}
          </div>
        </div>
      ))}
    </div>
  );
}
